module.exports = __webpack_public_path__ + "img/jcb.7da868c6.svg";